import React, { useState } from "react";
import "./filtermodal.scss";
import Modal from "react-bootstrap/Modal";
import { IconClose, IconDropDown } from "../../../icon/icons";
import { Autocomplete, Chip, TextField } from "@mui/material";
import FlatpickrInput from "../flatpickrall";
import "./filtermodal.scss";
const FilterModal = (props) => {
  const {
    showProfilemodal,
    handleCloseProfilemodal,
    filterFields,
    filterValues,
    handleFilterChange,
    isDatebtn,
    refComp,
    handleDateChange,
    clearFilters,
    handleApplyFilters,
  } = props;

  return (
    <>
      <Modal
        className="modal-all-data modal-big-data company-details-modal info-filter-modal"
        show={showProfilemodal}
        onHide={handleCloseProfilemodal}
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="closemodal_btn">
            <button onClick={handleCloseProfilemodal}>
              <IconClose />
            </button>
          </div>

          <div className="modal-inner-data-new">
            <div className="side_barcomman_main filters_data_drawer">
              <div className="side_bar_inner_data">
                <div className="filter-data-all-input">
                  {/* <div className="data-check-flex">
                    {checkboxData.map((item) => (
                      <div className="list-data-flex" key={item.id}>
                        <div className="input-main-data">
                          <div className="input-check">
                            <div className="remember_me_input">
                              <input type="checkbox" id={item.id} />
                              <label
                                htmlFor={item.id}
                                className="checkbox-label"
                              ></label>
                              <span>{item.label}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div> */}

                  <div className="data-check-flex">
                    {isDatebtn && (
                      <div className="select-data-flex">
                        <div className="input-main-data ">
                          <label>Date</label>
                        </div>
                        <div className="date-all-btn">
                          <FlatpickrInput
                            ref={refComp}
                            key={`${filterValues.startDate ||
                              ""}-${filterValues.endDate || ""}`}
                            mode="range"
                            value={
                              filterValues.startDate && filterValues.endDate
                                ? [filterValues.startDate, filterValues.endDate]
                                : []
                            }
                            onChange={handleDateChange}
                          />
                        </div>
                      </div>
                    )}
                    {filterFields.map((field) => (
                      <div className="select-data-flex">
                        <div className="input-main-data">
                          <label>{field?.label}</label>
                          {field?.type === "autocomplete" ? (
                            <Autocomplete
                              fullWidth
                              className="automcomplete_select_info"
                              options={field.options || []}
                              getOptionLabel={(option) => option?.title || option?.name || ""}
                              id="free-solo-demo"
                              popupIcon={<IconDropDown />}
                              value={
                                field.options?.find(
                                  (option) =>
                                    option.id === filterValues[field.name]
                                ) || null
                              }
                              onChange={(e, value) => {
                                handleFilterChange(
                                  field.name,
                                  value?.id || null
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={field.placeholder}
                                />
                              )}
                            />
                          ) : field?.type === "multiselect" ? (
                            <div className="input-main-data">
                              <Autocomplete
                                multiple
                                fullWidth
                                autoComplete={false}
                                className="automcomplete_select_info_multiple"
                                options={field.options || []}
                                  getOptionLabel={(option) => option?.title || ""}
                                  popupIcon={<IconDropDown />}
                                value={
                                  filterValues[field.name]?.map((id) =>
                                    field.options.find(
                                      (option) => option.id === id
                                    )
                                  ) || []
                                }
                                onChange={(e, value) => {
                                  const selectedIds = value.map(
                                    (item) => item.id
                                  );
                                  handleFilterChange(field.name, selectedIds);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder={field.placeholder}
                                  />
                                )}
                              
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ))}

                    {/* {fields.map((field) => (
                <div className="select-data-flex" key={field.id}>
                  <div className="input-main-data">
                    <label>{field.label}</label>
                    <Autocomplete
                      fullWidth
                      className="automcomplete_select_info"
                      autoComplete={false}
                      id={field.id}
                      options={TypesList}
                      getOptionLabel={(option) => option?.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={field.placeholder}
                        />
                      )}
                      value={selectedTypes[field.id] || null}
                      onChange={(e, value) => handleChange(field.id, value)}
                    />
                  </div>
                </div>
              ))} */}
                  </div>
                </div>

                <div className="btn-form-send">
                  <button
                    className="common-button"
                    type="button"
                    onClick={handleApplyFilters}
                  >
                    Filters
                  </button>
                  <button
                    className="common-button cancel-btn"
                    type="button"
                    onClick={clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FilterModal;
